import { Box /* , Tooltip */ } from 'react-scale/components';

const Stats = ({ stats, color = '#FFFFFF' }) => (
  <Box borderRadius={21}>
    <div className="flex flex-wrap px-10 gap-16 md:px-14 lg:px-16 flex-col justify-center space-y-8 md:flex-row bg-codGray rounded-2xl md:space-y-0 py-16">
      {stats.map((stat, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div className="text-center" key={index}>
          <Stat stat={stat} color={color} />
        </div>
      ))}
    </div>
  </Box>
);

// const StatWithTooltip = ({ stat, color = '#FFFFFF' }) => (
//   <Tooltip
//     content={
//       <div className="bg-gray-800 rounded-[4px] p-4 text-white">
//         “agree”, “disagree”, “neutral”
//         <br />
//         “can’t tell / unsure”
//       </div>
//     }
//     arrow={{
//       align: 'center',
//       width: 14,
//       height: 8,
//       className: 'fill-current text-gray-800'
//     }}
//   >
//     <span>
//       <p
//         style={{ color }}
//         className="text-[55px] leading-[62px] sm:text-6xl font-aeonik sm:leading-[72px] cursor-text"
//       >
//         4
//       </p>
//       <p className="uppercase text-sm tracking-[4px] leading-6">classes*</p>
//     </span>
//   </Tooltip>
// );

const Stat = ({ stat, color = '#FFFFFF' }) => (
  <>
    <p
      style={{ color }}
      className="text-[55px] leading-[62px] sm:text-6xl font-aeonik sm:leading-[72px]"
    >
      {stat.data}
    </p>
    <p className="uppercase text-sm tracking-[4px] leading-6 mx-auto max-w-[223px]">{stat.label}</p>
  </>
);

export default Stats;
